import {gql} from "@apollo/client";
import {REWARDMAPPING_ENTITY} from "../entities/rewardMappingEntity";

export const UPDATE_REWARDMAPPING = gql`
    ${REWARDMAPPING_ENTITY}
    mutation updateRewardMapping($data: RewardMappingInput!, $id: String!) {
      updateRewardMapping(data: $data, id: $id) {...RewardMappingEntity}
    }
`;